/**
 * All z-index's should be defined here to give a consistent hierarchy.
 */
enum zIndex {
  BackgroundVisualization = -1_000_000,
  Default,
  // Use auto for SeatGrid so it does not establish a new local stacking context and therefore the
  // text reaction (which will fall outside of the seat grid bounds) can go on top of other seat grids.
  SeatGrid = "auto",
  // Start at a high value to discourage engineers from hardcoding constants directly in CSS.
  SeatGridHeader = 1_000_000,
  AuditoriumStageLeftColumn,
  AuditoriumStagePresenterName,
  ChatMessageFromImageOrInitials,
  BottomSheet,
  MapDragSelection,
  SeatGridOverflowMenu,
  SeatGridDragging,
  SeatGridActive,
  SeatGridRemove,
  AuditoriumSeatPodHighlighted,
  CardViewPdfControls,
  CardViewStreamWaiting,
  CardViewStreamVideo,
  CardViewStreamOverlay,
  CardViewTopBar,
  CardViewFormatControls,
  CardViewResizeHandle,
  BoardToggleFullScreen,
  BoardControls,
  BoardPointer,
  BoardToolbar,
  Shelf,
  SeatEmojiReaction,
  SeatGridCursorNotAllowed,
  FloorElevator,
  FloorElevatorDraggingFloor,
  FloorElevatorOverlay,
  PanelsOverlay,
  NavHeader,
  WebsiteMobileHeaderExpanded,
  OverworldMessage,
  FloatingMeetingPanel,
  UserMediaControlsVideoPreview,
  WhiteboardReadOnlyOverlay,
  FullScreenControl,
  DockToolbar,
  InteractionPopup,
  InteractionPopupFocused,
  DropdownMenuOptions,
  KnockPopup,
  InteractionPopupControls,
  EmojiPicker,
  Tooltip,
  ShelfOpen,
  ShelfItemFloating,
  Modal,
  ChatTargetSuggestions,
  ToastsBar,
  WindowTitleBar,
  WindowTitleBarControls,
}

export default zIndex;
